"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _createSuper = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var collection_1 = require("./collection");

var Contact = /*#__PURE__*/function (_collection_1$Collect) {
  _inherits(Contact, _collection_1$Collect);

  var _super2 = _createSuper(Contact);

  function Contact() {
    var _this;

    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Contact);

    _this = _super2.call(this, attrs);
    _this.identifierChanged = false;
    return _this;
  }

  _createClass(Contact, [{
    key: "collectionName",
    value: function collectionName() {
      return Contact.collectionName;
    }
  }, {
    key: "constructIdentifier",
    value: function constructIdentifier() {
      // Create identifier based on first and last name
      return "".concat(this.attrs.firstName || '', " ").concat(this.attrs.lastName || '');
    }
  }, {
    key: "serialize",
    value: function serialize() {
      // Serialize to JSON
      return this.toJSON();
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return JSON.stringify(this.attrs);
    }
  }, {
    key: "save",
    value: function save(userSession) {
      var _this2 = this;

      var _super = Object.create(null, {
        save: {
          get: function get() {
            return _get(_getPrototypeOf(Contact.prototype), "save", _this2);
          }
        }
      });

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this3 = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", _super.save.call(this, userSession).then(function (result) {
                  if (_this3.identifierChanged) {
                    Contact.delete(_this3.previousIdentifier, userSession);
                  }

                  return result;
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "onValueChange",
    value: function onValueChange(key, value) {
      if (key === 'firstName') {
        this.previousIdentifier = this.attrs.identifier;
        this.attrs.identifier = this.constructIdentifier();
        this.identifierChanged = true;
      } else if (key === 'lastName') {
        this.previousIdentifier = this.attrs.identifier;
        this.attrs.identifier = this.constructIdentifier();
        this.identifierChanged = true;
      }
    }
  }], [{
    key: "fromData",
    value: function fromData(data) {
      return this.fromJSON(data);
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(data) {
      return new Contact(JSON.parse(data));
    }
  }, {
    key: "collectionName",
    get: function get() {
      return 'contact';
    }
  }]);

  return Contact;
}(collection_1.Collection);

exports.Contact = Contact;
Contact.schema = {
  identifier: String,
  firstName: String,
  lastName: String,
  blockstackID: String,
  email: String,
  website: String,
  address: String,
  telephone: String,
  organization: String
};